import Markdown from "markdown-to-jsx";
import styles from "./proposito.module.css";

export default function Proposito({ data }) {
  return (
    <section className={`container-full ${styles.container}`}>
      <div
        className={`flex-column-reverse align-items-center align-items-lg-start flex-lg-row ${styles.content}`}
      >
        <div>
          <img src={data.imagem.url} alt={data.titulo} />
        </div>
        <div className={styles.contentText}>
          <div className={styles.title}>
            <div className={styles.parallelogramDetail} />
            <h1>{data.titulo}</h1>
          </div>
          <Markdown>{data.texto}</Markdown>
        </div>
      </div>
    </section>
  );
}
